module.exports = __webpack_public_path__ + "img/20190703154229138.78d0ebff.png";